import { SvgIcon, SvgIconProps } from "@mui/material";

export const RangedCalendarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 8.33317H2.5M13.3333 1.6665V4.99984M6.66667 1.6665V4.99984M6.5 18.3332H13.5C14.9001 18.3332 15.6002 18.3332 16.135 18.0607C16.6054 17.821 16.9878 17.4386 17.2275 16.9681C17.5 16.4334 17.5 15.7333 17.5 14.3332V7.33317C17.5 5.93304 17.5 5.23297 17.2275 4.69819C16.9878 4.22779 16.6054 3.84534 16.135 3.60565C15.6002 3.33317 14.9001 3.33317 13.5 3.33317H6.5C5.09987 3.33317 4.3998 3.33317 3.86502 3.60565C3.39462 3.84534 3.01217 4.22779 2.77248 4.69819C2.5 5.23297 2.5 5.93304 2.5 7.33317V14.3332C2.5 15.7333 2.5 16.4334 2.77248 16.9681C3.01217 17.4386 3.39462 17.821 3.86502 18.0607C4.3998 18.3332 5.09987 18.3332 6.5 18.3332Z"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const RangedCalendarClearIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        transform: "scale(0.7)",
        transformOrigin: "center",
        fill: "none",
      }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const MediaUploadFieldIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      style={{ width: "44", height: "44", fill: "none" }}
    >
      <g filter="url(#filter0_d_32648_210022)">
        <rect x="2" y="1" width="40" height="40" rx="8" fill="white" shape-rendering="crispEdges" />
        <rect x="2.5" y="1.5" width="39" height="39" rx="7.5" stroke="#E4E7EC" shape-rendering="crispEdges" />
        <path
          d="M18.6667 24.3333L22 21M22 21L25.3334 24.3333M22 21V28.5M28.6667 24.9524C29.6846 24.1117 30.3334 22.8399 30.3334 21.4167C30.3334 18.8854 28.2813 16.8333 25.75 16.8333C25.5679 16.8333 25.3976 16.7383 25.3051 16.5814C24.2184 14.7374 22.212 13.5 19.9167 13.5C16.4649 13.5 13.6667 16.2982 13.6667 19.75C13.6667 21.4718 14.3629 23.0309 15.4891 24.1613"
          stroke="#475467"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_32648_210022"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_32648_210022" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_32648_210022" result="shape" />
        </filter>
      </defs>
    </SvgIcon>
  );
};

export const RemoveMediaButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "36", height: "36", fill: "none" }}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <rect width="36" height="36" rx="8" fill="white" />
      <path
        d="M21.3333 13.0003V12.3337C21.3333 11.4002 21.3333 10.9335 21.1517 10.577C20.9919 10.2634 20.7369 10.0084 20.4233 9.84865C20.0668 9.66699 19.6001 9.66699 18.6667 9.66699H17.3333C16.3999 9.66699 15.9332 9.66699 15.5767 9.84865C15.2631 10.0084 15.0081 10.2634 14.8483 10.577C14.6667 10.9335 14.6667 11.4002 14.6667 12.3337V13.0003M16.3333 17.5837V21.7503M19.6667 17.5837V21.7503M10.5 13.0003H25.5M23.8333 13.0003V22.3337C23.8333 23.7338 23.8333 24.4339 23.5608 24.9686C23.3212 25.439 22.9387 25.8215 22.4683 26.0612C21.9335 26.3337 21.2335 26.3337 19.8333 26.3337H16.1667C14.7665 26.3337 14.0665 26.3337 13.5317 26.0612C13.0613 25.8215 12.6788 25.439 12.4392 24.9686C12.1667 24.4339 12.1667 23.7338 12.1667 22.3337V13.0003"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const MediaFileIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "40", fill: "none" }}
      width="32"
      height="40"
      viewBox="0 0 32 40"
      fill="none"
    >
      <path
        d="M4 0.75H20C20.1212 0.75 20.2375 0.798088 20.3232 0.883789L31.1162 11.6768C31.2019 11.7625 31.25 11.8788 31.25 12V36C31.25 37.7949 29.7949 39.25 28 39.25H4C2.20507 39.25 0.75 37.7949 0.75 36V4C0.750001 2.20507 2.20508 0.75 4 0.75Z"
        fill="white"
        stroke="#D0D5DD"
        strokeWidth="1.5"
      />
      <path d="M20 0.5V8C20 10.2091 21.7909 12 24 12H31.5" stroke="#D0D5DD" strokeWidth="1.5" />
    </SvgIcon>
  );
};

export const DateFilterIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 8.33342H2.5M13.3333 1.66675V5.00008M6.66667 1.66675V5.00008M6.5 18.3334H13.5C14.9001 18.3334 15.6002 18.3334 16.135 18.0609C16.6054 17.8212 16.9878 17.4388 17.2275 16.9684C17.5 16.4336 17.5 15.7335 17.5 14.3334V7.33342C17.5 5.93328 17.5 5.23322 17.2275 4.69844C16.9878 4.22803 16.6054 3.84558 16.135 3.6059C15.6002 3.33341 14.9001 3.33341 13.5 3.33341H6.5C5.09987 3.33341 4.3998 3.33341 3.86502 3.6059C3.39462 3.84558 3.01217 4.22803 2.77248 4.69844C2.5 5.23322 2.5 5.93328 2.5 7.33341V14.3334C2.5 15.7335 2.5 16.4336 2.77248 16.9684C3.01217 17.4388 3.39462 17.8212 3.86502 18.0609C4.3998 18.3334 5.09987 18.3334 6.5 18.3334Z"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const DateFilterClearIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "10", height: "10", fill: "none" }}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path d="M9 1L1 9M9 9L1 1" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const DateFilterArrowRightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "8", height: "12", fill: "none" }}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
    >
      <path
        d="M1.5 11L6.5 6L1.5 1"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const DateFilterArrowLeftIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "8", height: "12", fill: "none" }}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
    >
      <path
        d="M6.5 11L1.5 6L6.5 1"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CloseIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "14", fill: "none" }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M12.8925 0.3025C12.5025 -0.0874998 11.8725 -0.0874998 11.4825 0.3025L6.5925 5.1825L1.7025 0.2925C1.3125 -0.0975 0.6825 -0.0975 0.2925 0.2925C-0.0975 0.6825 -0.0975 1.3125 0.2925 1.7025L5.1825 6.5925L0.2925 11.4825C-0.0975 11.8725 -0.0975 12.5025 0.2925 12.8925C0.6825 13.2825 1.3125 13.2825 1.7025 12.8925L6.5925 8.0025L11.4825 12.8925C11.8725 13.2825 12.5025 13.2825 12.8925 12.8925C13.2825 12.5025 13.2825 11.8725 12.8925 11.4825L8.0025 6.5925L12.8925 1.7025C13.2725 1.3225 13.2725 0.6825 12.8925 0.3025Z"
        fill="#0B0B0B"
      />
    </SvgIcon>
  );
};
